import { Component, OnInit } from '@angular/core';
import data from "../../data/footerlinks.json";
import { BlogHelperService } from '../../helper/blog/blog-helper.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent extends BlogHelperService implements OnInit  {
  public links = data; 
  currentYear!: number;

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
  }
}
